export enum PaymentProvider {
    Adyen = 'Adyen',
    Atos = 'Atos',
    Network = 'Network', // also named ngenius for an unkown reason
    None = 'None',
    Paynl = 'Paynl',
}
